export class Accordion {
    constructor(data) {
        if (!this.set(data)) return;
        this.init();
    }

    set(data) {
        const { el, collapse, firstExpanded } = data;
        if (!el) return;

        this.root = el;
        this.collapse = collapse || false;
        this.firstExpanded = firstExpanded || false;
        this.accordionElement = el.querySelector('.accordion');
        this.accordionItems = el.querySelectorAll('.accordion__item');
        if (!this.accordionElement) return;

        return true;
    }

    init() {
        this.setAccordionItemsData();
        this.handleClickEvent();
        this.handleExpandedElementEvent();
        if (this.firstExpanded) this.handleFirstClick();
    }

    setAccordionItemsData() {
        if (this.accordionItems.length === 0) return;
        this.accordionItems.forEach((element, key) => {
            element.setAttribute('data-key', key);
        });
    }

    handleClickEvent() {
        const buttons = this.accordionElement.querySelectorAll(
            '.accordion__item-button'
        );
        buttons.forEach(button => {
            const parent = button.parentElement;
            button.addEventListener('click', () =>
                this.handleButtonClick(parent)
            );
        });
    }

    handleFirstClick() {
        const buttons = this.accordionElement.querySelectorAll(
            '.accordion__item-button'
        );
        const parent = buttons[0].parentElement;
        this.handleButtonClick(parent);
    }

    handleButtonClick(parent) {
        const bodyElement = parent.querySelector('.accordion__item-body');
        const heightElement = parent.querySelector(
            '.accordion__item-body-height'
        );
        const parentKey = parent.getAttribute('data-key');
        if (!heightElement || !bodyElement) return;

        if (parent.classList.contains('expanded')) {
            parent.classList.remove('expanded');
            bodyElement.style.height = '0px';
        } else {
            parent.classList.add('expanded');
            bodyElement.style.height = `${heightElement.offsetHeight}px`;
        }

        if (this.collapse) {
            const items = this.root.querySelectorAll('.accordion__item');

            items.forEach((item, key) => {
                const childKey = item.getAttribute('data-key');
                if (childKey === parentKey) return;
                const itemBodyElement = item.querySelector(
                    '.accordion__item-body'
                );
                item.classList.remove('expanded');
                itemBodyElement.style.height = '0px';
            });
        }
    }

    handleExpandedElementEvent() {
        window.addEventListener("resize", this.handleExpanedElementHeight.bind(this));
    }

    handleExpanedElementHeight() {
        console.log("Test");
        const expandedItem = this.root.querySelector(".schedule__item.expanded");
        if (!expandedItem) return;

        const heightElement = expandedItem.querySelector(
            '.accordion__item-body-height'
        );
        const bodyElement = expandedItem.querySelector('.accordion__item-body');

        bodyElement.style.height = `${heightElement.offsetHeight}px`;
    }
}
